import React, { useEffect, useRef, useState } from "react";

import { classNames } from "primereact/utils";
import { Route, Routes } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";

import AppTopbar from "./AppTopbar";
import AppInlineMenu from "./AppInlineMenu";

import AppMenu from "./AppMenu";
import AppConfig from "./AppConfig";
import AppRightMenu from "./AppRightMenu";
import Recuperar from "./pages/Recuperar";
import Contactos from "./pages/Contactos";
import Contacto from "./pages/Contacto";
import Direccion from "./pages/Direccion";

import PrimeReact from "primereact/api";
import { Tooltip } from "primereact/tooltip";

import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "./App.scss";

import AppContext from "./Config";
import { useGlobalContext } from "./Config";
import BlankPage from "./pages/BlankPage";
import SSO from "./components/sso";

export const RTLContext = React.createContext();

const App = () => {
  const [menuMode, setMenuMode] = useState("static");
  const [inlineMenuPosition, setInlineMenuPosition] = useState("bottom");
  const [desktopMenuActive, setDesktopMenuActive] = useState(true);
  const [mobileMenuActive, setMobileMenuActive] = useState(false);
  const [activeTopbarItem, setActiveTopbarItem] = useState(null);
  const [colorMode, setColorMode] = useState("light");
  const [rightMenuActive, setRightMenuActive] = useState(false);
  const [menuActive, setMenuActive] = useState(false);
  const [inputStyle, setInputStyle] = useState("filled");
  const [isRTL, setRTL] = useState(false);
  const [ripple, setRipple] = useState(true);
  const [mobileTopbarActive, setMobileTopbarActive] = useState(false);
  const [menuTheme, setMenuTheme] = useState("light");
  const [topbarTheme, setTopbarTheme] = useState("blue");
  const [theme, setTheme] = useState("indigo");
  const [isInputBackgroundChanged, setIsInputBackgroundChanged] =
    useState(false);
  const [inlineMenuActive, setInlineMenuActive] = useState({});
  const [newThemeLoaded, setNewThemeLoaded] = useState(false);
  const [searchActive, setSearchActive] = useState(false);
  const { isRecuperar } = useGlobalContext();
  const { setIsRecuperar } = useGlobalContext();
  const { setIsLoggedIn } = useGlobalContext();
  const { baseUrl, headerText } = useGlobalContext();
  const copyTooltipRef = useRef();
  let currentInlineMenuKey = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();

  const [contrasenaRestablecida, setContrasenaRestablecida] = useState(false);
  const [debeCrearContrasena, setDebeCrearContrasena] = useState(false);
  const [correoUsuario, setCorreoUsuario] = useState("");
  const [loading, setLoading] = useState(false);

  const [privilegios, setPrivilegios] = useState();
  const { isLoggedIn } = useGlobalContext();
  const { setUsuarioId } = useGlobalContext();

  PrimeReact.ripple = true;

  let searchClick;
  let topbarItemClick;
  let menuClick;
  let inlineMenuClick;

  var customMenu = [];
  customMenu[0] = {
    label: "Menu",
    icon: "pi pi-fw pi-list",
    items: [],
  };

  if (sessionStorage.getItem("param1") === "true" || true) {
    customMenu[0]["items"].push(
      //{
      //label: "Reportes",
      //icon: "pi pi-fw pi-list",
      //items: [
      //{
      //label: "Tabla",
      //icon: "pi pi-fw pi-list",
      //to: "/tabla",
      //},
      //],
      //},
      { label: "Contactos", icon: "pi pi-user", to: "/contactos" }
    );
  }

  if (sessionStorage.getItem("perfil") == 1) {
    customMenu[0]["items"].push({
      label: "Administración",
      icon: "pi pi-fw pi-list",
      items: [
        {
          label: "Usuarios",
          icon: "pi pi-fw pi-list",
          to: "/usuarios",
        },
      ],
    });
  }

  if (sessionStorage.getItem("perfil") == 2) {
  }

  const menu = customMenu;

  const userPrivilegios =
    JSON.parse(sessionStorage.getItem("privilegios")) || [];

  const routes = [{ path: "/", parent: "", label: "Login" }];

  useEffect(() => {
    const checkSSOLogin = async () => {
      try {
        const response = await fetch("https://sso.kesp.cl/sso/rest/user", {
          method: "GET",
          credentials: "include",
        });

        if (response.ok) {
          const userData = await response.json();

          // ⚠️ Primero: Verificar si tiene acceso a esta app
          const app = "CONTACTOS";
          if (!userData.apps || !userData.apps.includes(app)) {
            alert("No está autorizado para acceder a esta aplicación.");
            return; // ❌ No continuar si no tiene acceso
          }

          // ✅ Parsear atributos de forma segura (puede venir string u objeto)
          const attrsRaw = userData.atributos;
          let parsedAtributos = {};
          try {
            parsedAtributos =
              typeof attrsRaw === "string"
                ? JSON.parse(attrsRaw)
                : attrsRaw || {};
          } catch (e) {
            console.error("Atributos inválidos:", e, attrsRaw);
            alert("No se pudo leer la configuración de permisos del usuario.");
            return;
          }

          // ✅ Tomar la empresa activa y buscar la configuración de la app
          const empresaActivaKey = String(userData.empresa ?? ""); // p.ej. "2"
          const getAppData = (attrs, empresaKey, appName) => {
            // 1) Intentar por empresa activa
            if (empresaKey && attrs[empresaKey] && attrs[empresaKey][appName]) {
              return attrs[empresaKey][appName];
            }
            // 2) Fallback: buscar en cualquier empresa
            for (const key of Object.keys(attrs)) {
              if (attrs[key] && attrs[key][appName]) {
                return attrs[key][appName];
              }
            }
            return null;
          };

          const appData = getAppData(parsedAtributos, empresaActivaKey, app);

          if (!appData) {
            alert(
              "No se encontró configuración de permisos para esta app en la empresa activa."
            );
            return;
          }

          // ✅ Guardar en sessionStorage lo necesario
          sessionStorage.setItem("isLoggedIn", "true");
          sessionStorage.setItem("apellido", userData.apellido);
          sessionStorage.setItem("roles", JSON.stringify(userData.roles));
          sessionStorage.setItem("userId", userData.id);
          sessionStorage.setItem("username", userData.usuario);
          sessionStorage.setItem("nombre", userData.nombre);
          sessionStorage.setItem("empresaActiva", String(userData.empresa)); // opcional, útil luego
          sessionStorage.setItem("perfil", appData.perfil ?? "");
          sessionStorage.setItem("permisos", appData.permisos ?? "[]"); // viene como string JSON en tu ejemplo

          setIsLoggedIn(true);

          if (location.pathname === "/" || location.pathname === "/index.htm") {
            navigate("/contactos");
          }
        } else {
          console.warn("No autenticado, redirigiendo a SSO...");
          window.location.href = "https://sso.kesp.cl";
        }
      } catch (error) {
        console.error("Error al verificar el usuario:", error);
        window.location.href = "https://sso.kesp.cl";
      }
    };

    const isLoggedInStorage = sessionStorage.getItem("isLoggedIn") === "true";
    if (!isLoggedInStorage) {
      checkSSOLogin();
    }
  }, []);

  useEffect(() => {
    copyTooltipRef &&
      copyTooltipRef.current &&
      copyTooltipRef.current.updateTargetEvents();
  }, [location]);

  useEffect(() => {
    if (menuMode === "overlay") {
      hideOverlayMenu();
    }
    if (menuMode === "static") {
      setDesktopMenuActive(true);
    }
  }, [menuMode]);

  useEffect(() => {
    onColorModeChange(colorMode);
  }, []);

  const onMenuThemeChange = (theme) => {
    setMenuTheme(theme);
  };

  const onTopbarThemeChange = (theme) => {
    setTopbarTheme(theme);
  };

  const onThemeChange = (theme) => {
    setTheme(theme);
    const themeLink = document.getElementById("theme-css");
    const themeHref = "assets/theme/" + theme + "/theme-" + colorMode + ".css";
    replaceLink(themeLink, themeHref);
  };

  const onColorModeChange = (mode) => {
    setColorMode(mode);
    setIsInputBackgroundChanged(true);

    if (isInputBackgroundChanged) {
      if (mode === "dark") {
        setInputStyle("filled");
      } else {
        setInputStyle("outlined");
      }
    }

    if (mode === "dark") {
      setMenuTheme("dark");
      setTopbarTheme("dark");
    } else {
      setMenuTheme("light");
      setTopbarTheme("blue");
    }

    const layoutLink = document.getElementById("layout-css");
    const layoutHref = "assets/layout/css/layout-" + mode + ".css";
    replaceLink(layoutLink, layoutHref);

    const themeLink = document.getElementById("theme-css");
    const urlTokens = themeLink.getAttribute("href").split("/");
    urlTokens[urlTokens.length - 1] = "theme-" + mode + ".css";
    const newURL = urlTokens.join("/");

    replaceLink(themeLink, newURL, () => {
      setNewThemeLoaded(true);
    });
  };

  const replaceLink = (linkElement, href, callback) => {
    if (isIE()) {
      linkElement.setAttribute("href", href);

      if (callback) {
        callback();
      }
    } else {
      const id = linkElement.getAttribute("id");
      const cloneLinkElement = linkElement.cloneNode(true);

      cloneLinkElement.setAttribute("href", href);
      cloneLinkElement.setAttribute("id", id + "-clone");

      linkElement.parentNode.insertBefore(
        cloneLinkElement,
        linkElement.nextSibling
      );

      cloneLinkElement.addEventListener("load", () => {
        linkElement.remove();
        const _linkElement = document.getElementById(id);
        _linkElement && _linkElement.remove();
        cloneLinkElement.setAttribute("id", id);
        if (callback) {
          callback();
        }
      });
    }
  };

  const onInputStyleChange = (inputStyle) => {
    setInputStyle(inputStyle);
  };

  const onRipple = (e) => {
    PrimeReact.ripple = e.value;
    setRipple(e.value);
  };

  const onInlineMenuPositionChange = (mode) => {
    setInlineMenuPosition(mode);
  };

  const onMenuModeChange = (mode) => {
    setMenuMode(mode);
  };

  const onRTLChange = () => {
    setRTL((prevState) => !prevState);
  };

  const onMenuClick = (event) => {
    menuClick = true;
  };

  const onMenuButtonClick = (event) => {
    menuClick = true;

    if (isDesktop()) setDesktopMenuActive((prevState) => !prevState);
    else setMobileMenuActive((prevState) => !prevState);

    event.preventDefault();
  };

  const onTopbarItemClick = (event) => {
    topbarItemClick = true;
    if (activeTopbarItem === event.item) setActiveTopbarItem(null);
    else {
      setActiveTopbarItem(event.item);
    }

    event.originalEvent.preventDefault();
  };

  const onSearch = (event) => {
    searchClick = true;
    setSearchActive(event);
  };

  const onMenuItemClick = (event) => {
    if (!event.item.items && (menuMode === "overlay" || !isDesktop())) {
      hideOverlayMenu();
    }

    if (!event.item.items && (isHorizontal() || isSlim())) {
      setMenuActive(false);
    }
  };

  const onRootMenuItemClick = (event) => {
    setMenuActive((prevState) => !prevState);
  };

  const onRightMenuButtonClick = () => {
    setRightMenuActive((prevState) => !prevState);
  };

  const onMobileTopbarButtonClick = (event) => {
    setMobileTopbarActive((prevState) => !prevState);
    event.preventDefault();
  };

  const onDocumentClick = (event) => {
    if (!searchClick && event.target.localName !== "input") {
      setSearchActive(false);
    }

    if (!topbarItemClick) {
      setActiveTopbarItem(null);
    }

    if (!menuClick && (menuMode === "overlay" || !isDesktop())) {
      if (isHorizontal() || isSlim()) {
        setMenuActive(false);
      }
      hideOverlayMenu();
    }

    if (inlineMenuActive[currentInlineMenuKey.current] && !inlineMenuClick) {
      let menuKeys = { ...inlineMenuActive };
      menuKeys[currentInlineMenuKey.current] = false;
      setInlineMenuActive(menuKeys);
    }

    if (!menuClick && (isSlim() || isHorizontal())) {
      setMenuActive(false);
    }

    searchClick = false;
    topbarItemClick = false;
    inlineMenuClick = false;
    menuClick = false;
  };

  const hideOverlayMenu = () => {
    setMobileMenuActive(false);
    setDesktopMenuActive(false);
  };

  const isDesktop = () => {
    return window.innerWidth > 1024;
  };

  const isHorizontal = () => {
    return menuMode === "horizontal";
  };

  const isSlim = () => {
    return menuMode === "slim";
  };

  const isIE = () => {
    return /(MSIE|Trident\/|Edge\/)/i.test(window.navigator.userAgent);
  };

  const onInlineMenuClick = (e, key) => {
    let menuKeys = { ...inlineMenuActive };
    if (key !== currentInlineMenuKey.current && currentInlineMenuKey.current) {
      menuKeys[currentInlineMenuKey.current] = false;
    }

    menuKeys[key] = !menuKeys[key];
    setInlineMenuActive(menuKeys);
    currentInlineMenuKey.current = key;
    inlineMenuClick = true;
  };

  const layoutContainerClassName = classNames(
    "layout-wrapper ",
    "layout-menu-" + menuTheme + " layout-topbar-" + topbarTheme,
    {
      "layout-menu-static": menuMode === "static",
      "layout-menu-overlay": menuMode === "overlay",
      "layout-menu-slim": menuMode === "slim",
      "layout-menu-horizontal": menuMode === "horizontal",
      "layout-menu-active": desktopMenuActive,
      "layout-menu-mobile-active": mobileMenuActive,
      "layout-topbar-mobile-active": mobileTopbarActive,
      "layout-rightmenu-active": rightMenuActive,
      "p-input-filled": inputStyle === "filled",
      "p-ripple-disabled": !ripple,
      "layout-rtl": isRTL,
    }
  );

  const handleRecuperarContraseña = (emailRecuperar) => {
    setLoading(true);
    const checkRecuperarContraseña = async () => {
      try {
        const emailFormat = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailFormat.test(emailRecuperar)) {
          alert("Ingrese un formato de correo válido");
          setLoading(false);

          return;
        }

        const response = await fetch(
          baseUrl + "recuperarContrasena?usuario=" + emailRecuperar
        );
        if (response.status === 401) {
          alert("Usuario o clave inválida");
          setLoading(false);

          return;
        }
        if (response.status === 500) {
          alert("Error interno del servidor");
          setLoading(false);

          return;
        }
        if (response.status === 200) {
          const data = await response.json();
          if (data.respuesta) {
            setLoading(false);

            setContrasenaRestablecida(true);
          }
        }
      } catch (error) {
        setLoading(false);

        console.error(error);
      }
    };
    checkRecuperarContraseña();
  };

  const handleCrearNuevaContrasena = (oldPass, newPass) => {
    const checkCrearContrasena = async () => {
      try {
        setLoading(true);

        const response = await fetch(
          baseUrl +
            `cambiarContrasena?usuario=${correoUsuario}&pass=${oldPass}&nueva=${newPass} `
        );

        if (response.status === 200) {
          const data = await response.json();
          if (data.respuesta) {
            alert("Por favor ingrese con la contraseña que acaba de crear");
            setDebeCrearContrasena(false);
            navigate("/");
          } else {
            alert("Hubo un error al crear la contraseña");
          }
        }
      } catch (error) {
        console.error(error);
      }
    };
    checkCrearContrasena();
    setLoading(false);
  };

  const handleVolverInicio = () => {
    setIsRecuperar(false);
  };

  const handleButtonClickRecuperar = () => {
    setIsRecuperar(true);
    setContrasenaRestablecida(false);
  };
  const isLoggedInStorage = sessionStorage.getItem("isLoggedIn") === "true";

  //if (!isLoggedInStorage && !isRecuperar && !debeCrearContrasena) {
  //return (
  //<Login
  //colorMode="light"
  //isNewThemeLoaded={false}
  //onNewThemeChange={() => {}}
  //location={location}
  //handleLogin={handleLogin}
  //handleButtonClickRecuperar={handleButtonClickRecuperar}
  ///>
  //);
  //}

  if (!isLoggedInStorage && isRecuperar) {
    return (
      <Recuperar
        colorMode="light"
        isNewThemeLoaded={false}
        onNewThemeChange={() => {}}
        location={location}
        handleRecuperarContraseña={handleRecuperarContraseña}
        handleVolverInicio={handleVolverInicio}
        contrasenaRestablecida={contrasenaRestablecida}
        loading={loading}
        setLoading={setLoading}
      />
    );
  }

  return (
    <RTLContext.Provider value={isRTL}>
      <AppContext>
        {" "}
        <div className={layoutContainerClassName} onClick={onDocumentClick}>
          <Tooltip
            ref={copyTooltipRef}
            target=".block-action-copy"
            position="bottom"
            content="Copied to clipboard"
            event="focus"
          />

          <AppTopbar
            horizontal={isHorizontal()}
            activeTopbarItem={activeTopbarItem}
            onMenuButtonClick={onMenuButtonClick}
            onTopbarItemClick={onTopbarItemClick}
            onRightMenuButtonClick={onRightMenuButtonClick}
            onMobileTopbarButtonClick={onMobileTopbarButtonClick}
            mobileTopbarActive={mobileTopbarActive}
            searchActive={searchActive}
            onSearch={onSearch}
            clientId={sessionStorage.getItem("clientId")}
          />

          <SSO />

          {(() => {
            if (isLoggedInStorage) {
              return (
                <>
                  <div className="menu-wrapper" onClick={onMenuClick}>
                    <div className="layout-menu-container">
                      {(inlineMenuPosition === "top" ||
                        inlineMenuPosition === "both") && (
                        <AppInlineMenu
                          menuKey="top"
                          inlineMenuActive={inlineMenuActive}
                          onInlineMenuClick={onInlineMenuClick}
                          horizontal={isHorizontal()}
                          menuMode={menuMode}
                        />
                      )}
                      <AppMenu
                        model={menu}
                        onMenuItemClick={onMenuItemClick}
                        onRootMenuItemClick={onRootMenuItemClick}
                        menuMode={menuMode}
                        active={menuActive}
                      />
                    </div>
                  </div>
                </>
              );
            }
          })()}

          <div className="layout-main">
            <div className="layout-content">
              <Routes>
                <Route path="/" element={<BlankPage />} location={location} />
                <Route
                  path="/contactos"
                  element={
                    <Contactos
                      colorMode={colorMode}
                      isNewThemeLoaded={newThemeLoaded}
                      onNewThemeChange={(e) => setNewThemeLoaded(e)}
                      location={location}
                      proveedor={sessionStorage.getItem("proveedor")}
                      perfil={sessionStorage.getItem("perfil")}
                    />
                  }
                />
                <Route
                  path="/contacto/:id"
                  element={
                    <Contacto
                      colorMode={colorMode}
                      isNewThemeLoaded={newThemeLoaded}
                      onNewThemeChange={(e) => setNewThemeLoaded(e)}
                      location={location}
                      proveedor={sessionStorage.getItem("proveedor")}
                      perfil={sessionStorage.getItem("perfil")}
                    />
                  }
                />
                <Route
                  path="/direccion/:id"
                  element={
                    <Direccion
                      colorMode={colorMode}
                      isNewThemeLoaded={newThemeLoaded}
                      onNewThemeChange={(e) => setNewThemeLoaded(e)}
                      location={location}
                      proveedor={sessionStorage.getItem("proveedor")}
                      perfil={sessionStorage.getItem("perfil")}
                    />
                  }
                />
              </Routes>
            </div>
          </div>

          <AppConfig
            inputStyle={inputStyle}
            onInputStyleChange={onInputStyleChange}
            rippleEffect={ripple}
            onRippleEffect={onRipple}
            menuMode={menuMode}
            onMenuModeChange={onMenuModeChange}
            inlineMenuPosition={inlineMenuPosition}
            onInlineMenuPositionChange={onInlineMenuPositionChange}
            colorMode={colorMode}
            onColorModeChange={onColorModeChange}
            menuTheme={menuTheme}
            onMenuThemeChange={onMenuThemeChange}
            topbarTheme={topbarTheme}
            onTopbarThemeChange={onTopbarThemeChange}
            theme={theme}
            onThemeChange={onThemeChange}
            isRTL={isRTL}
            onRTLChange={onRTLChange}
          />

          <AppRightMenu
            rightMenuActive={rightMenuActive}
            onRightMenuButtonClick={onRightMenuButtonClick}
            display="none"
          />

          {mobileMenuActive && <div className="layout-mask modal-in"></div>}
        </div>
      </AppContext>
    </RTLContext.Provider>
  );
};

export default App;
